export const payoutsTable = {
  header: 'All Payouts',
  title: 'Payouts',
  id: 'Payout Id',
  status: 'Status',
  company: 'Company',
  transactions: 'Transactions',
  gross: 'Gross Value',
  net: 'Net Value',
  estArrival: 'Est Arrival',
  refundAmt: 'Refund Amt',
  transferAmt: 'Transfer Amt',
};

export const rowActions = {
  view: 'View Payout Details',
  export: 'Export Payout Transactions',
};

export const payoutDetails = {
  header1: 'Payout',

  detailsHeader: 'Payout Details',
  rawDataHeader: 'Raw Data',
  webhookHeader: 'Webhook Table',
  transferHeader: 'Transfer Breakdown',

  expectedArrival: 'Expected arrival: ',
  export: 'Export Details',
  net: payoutsTable.net,
  transaction_count: 'Transaction Count',
  gross: payoutsTable.gross,
  estimated_arrival: 'Estimated Arrival',
  refund_count: 'Refund Count',
  refund_amount: 'Refund Amount',
  transfers: 'Transfers',
  transfer_amount: 'Transfer Amount',
};
